import React, { useEffect, useState } from "react";

const CalloutSection = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="full-white-section">
      <p
        className={`callout fade-up ${isVisible ? "visible" : ""}`}
        style={{ marginTop: "0px" }}
      >
        R&D at the core, software as the engine,{" "}
        <span className={`slide-text ${isVisible ? "visible" : ""}`}>
          AI Fuel
        </span>{" "}
        in every decision - transforming mission and enterprises and mission in
        real time
      </p>
    </section>
  );
};

export default CalloutSection;
 
